import { SlideCardInterface } from '../../component-lib/components/slide-card/slide-card.interface';

export interface ChargingIntroductionModel {
  items: SlideCardInterface[];
}

export enum IntroductionType {
  skipIntroChargingCard = 'skipIntroChargingCard',
  skipIntroChargingStation = 'skipIntroChargingStation',
}
